import 'twin.macro';
import React from 'react';
import clsx from 'clsx';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export function DescriptionList(props: Props) {
  const { children } = props;
  return (
    <dl tw="space-y-4" className={clsx(props.className)}>
      {children}
    </dl>
  );
}

interface ItemProps {
  label: string;
  children: React.ReactNode;
}

export function Item(props: ItemProps) {
  const { children, label } = props;
  return (
    <div>
      <dt tw="text-sm font-medium text-neutral-quiet">{label}</dt>
      <dd>{children}</dd>
    </div>
  );
}

DescriptionList.Item = Item;
